<template>
    <div>
        <FullscreenLoading v-if="isLoading" />

        <Modal :show="showEditModal" @close="showEditModal = false" :custom_modal_class="'modal-xs fullwidth-modal'">
            <div slot="header">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('users.edit_title') }}</h5>
                    <button type="button" class="close" @click="showEditModal = false" aria-label="Close"><span aria-hidden="true">×</span></button>
                </div>
            </div>

            <div slot="body">
                <EditUserForm
                    v-if="showEditModal && user"
                    :user="user"
                    @submit="updateUser"
                    form-id="editUserForm"
                    :is-loading="isLoading"
                    :errors="formErrors"
                />
            </div>

            <div slot="footer" class="w-100">
                <button
                    type="button"
                    class="btn btn-secondary btn-sm"
                    data-dismiss="modal"
                    @click="showEditModal = false"
                    :disabled="isLoading"
                >
                    {{ $t('general.close') }}
                </button>

                <button
                    type="submit"
                    form="editUserForm"
                    class="btn btn-primary btn-sm float-right"
                    data-dismiss="modal"
                >
                    {{ $t('users.edit_button') }}
                </button>
            </div>
        </Modal>
    </div>
</template>
<script setup>
    import Modal from '../Modal.vue';
    import { ref, watch } from 'vue';
    import { notifyError, notifySuccess } from '../../utils/notify';
    import { UserService } from '../../services/userService';
    import i18n from '../../utils/locale';
    import FullscreenLoading from '../FullscreenLoading.vue';
    import EditUserForm from '../../forms/users/EditUserForm.vue';

    const emit = defineEmits(['close', 'updated']);
    const props = defineProps({
        user: {
            type: Object,
            required: true,
        },

        admin: {
            type: Boolean,
            default: false
        }
    });

    const showEditModal = ref(true);
    const isLoading = ref(false);
    const formErrors = ref(null);

    watch(() => showEditModal.value, () => {
        emit('close');
    });

    async function updateUser(data) {
        isLoading.value = true;

        try {
            await UserService.getInstance().updateUser(props.user.id, data, props.admin);
            emit('updated');
            notifySuccess(i18n.t('users.user_updated'));
        } catch (exception) {
            formErrors.value = exception?.response?.data?.errors || {
                role: [i18n.t('general.something_went_wrong')],
            };

            notifyError(exception);
        } finally {
            isLoading.value = false;
        }
    }
</script>
